import { render } from "./LogoutSuccess.vue?vue&type=template&id=7b25a326"
import script from "./LogoutSuccess.vue?vue&type=script&lang=js"
export * from "./LogoutSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antion/git/vuetest/vuetest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__